import { toPlainTextSync } from 'ricos-content/libs/toPlainTextSync';

export default function contentStateToString(contentState) {
  return toPlainTextSync(contentState, {
    urlShortener: () => '',
    getVideoUrl: () => '',
    getAudioUrl: () => '',
    getVideoEmbeddedUrl: () => '',
    getGifUrl: () => '',
    addLinksToText: false,
  });
}
